module.exports = __webpack_public_path__ + "img/free_bidding_quit.3a40e69c.png";